import { Card } from "primereact/card"
import { Link } from "react-router-dom"
import styles from "../../styles/Home.module.css"
import recoveryPlanIcon from "../../assets/icons/recovery_plan_icon.svg"
import assessmentsIcon from "../../assets/icons/assessments_icon.svg"
import telerecoveryIcon from "../../assets/icons/telerecovery_icon.svg"
import engagementsIcon from "../../assets/icons/engagements_icon.svg"
import referralsIcon from "../../assets/icons/referrals_icon.svg"
import documentsIcon from "../../assets/icons/documents_icon.svg"
import serviceEpisodesIcon from "../../assets/icons/service_episodes_icon.svg"
import preferencesIcon from "../../assets/icons/preferences_icon.svg"
import customDataFormsIcon from "../../assets/icons/custom_data_forms_icon.svg"
import supportIcon from "../../assets/icons/support_icon.svg"
import ROUTES from "../../components/Routes/routesContants"
import "primeflex/primeflex.css"

export default function Homepage() {
  const cards = [
    {
      title: "Engagements",
      icon: engagementsIcon,
      to: ROUTES.PARTICIPANT_ENGAGEMENTS,
    },
    {
      title: "Assessments",
      icon: assessmentsIcon,
      to: ROUTES.PARTICIPANT_ASSESSMENTS,
    },
    {
      title: "Recovery Plan",
      icon: recoveryPlanIcon,
      to: ROUTES.PARTICIPANT_RECOVERY_PLAN,
    },
    {
      title: "Documents",
      icon: documentsIcon,
      to: ROUTES.PARTICIPANT_DOCUMENTS,
    },
    {
      title: "Telerecovery",
      icon: telerecoveryIcon,
      to: ROUTES.PARTICIPANT_TELERECOVERY_SERVICES + "/chat",
    },
    {
      title: "Referrals",
      icon: referralsIcon,
      to: ROUTES.PARTICIPANT_REFERRALS,
    },
    {
      title: "Custom Forms",
      icon: customDataFormsIcon,
      to: ROUTES.PARTICIPANT_CUSTOM_FORMS,
    },
    {
      title: "Service Episodes",
      icon: serviceEpisodesIcon,
      to: ROUTES.PARTICIPANT_SERVICE_EPISODES,
    },
    {
      title: "Preferences",
      icon: preferencesIcon,
      to: ROUTES.PREFERENCES_ACCOUNT,
    },
    {
      title: "Support",
      icon: supportIcon,
      to: "https://help.myrecoverylink.com/",
      target: "_blank",
    },
  ]

  // Sorting: Alphabetically except "Preferences" and "Support" at the end
  // const sortedCards = [
  //   ...cards
  //     .filter(
  //       (card) => card.title !== "Preferences" && card.title !== "Support"
  //     )
  //     .sort((a, b) => a.title.localeCompare(b.title)),
  //   cards.find((card) => card.title === "Preferences"),
  //   cards.find((card) => card.title === "Support"),
  // ]

  return (
    <main className="p-4" style={{ marginTop: "10px" }}>
      <div className="grid">
        {cards.map((card, index) => (
          <div key={index} className="col-6 sm:col-6 md:col-3">
            <Link
              to={card.to}
              target={card.target ?? "_self"}
              className="no-underline"
            >
              <Card className="p-3 text-center shadow-2 border-round home_tile">
                <div className={styles.card_content}>
                  <img
                    src={card.icon}
                    alt={card.title}
                    className="w-3rem h-3rem mb-2 home_icon"
                  />
                  <span className="font-medium">{card.title}</span>
                </div>
              </Card>
            </Link>
          </div>
        ))}
      </div>
    </main>
  )
}
